// src/arca_Utilities/useAuthNavigation.js
import { useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '../arca_Auth/AuthContext';
import { toast } from 'react-toastify';

export const useAuthNavigation = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { login, logout } = useAuth();

  // Handle successful authentication
  const handleAuthSuccess = (userData) => {
    console.log('🔐 handleAuthSuccess called with userData:', userData);

    login(userData);

    // If user must change password, redirect to force change password page
    if (userData.mustChangePassword) {
      toast.warning('You must change your password before continuing.');
      navigate('/force-change-password', { replace: true, state: { email: userData.email } });
      return;
    }

    toast.success('Login successful!');

    // Role-based redirection
    let redirectPath;
    const userRole = userData.userType || userData.role;

    console.log('👤 User role detected:', userRole);

    if (userRole === 'admin' || userRole === 'super_admin') {
      redirectPath = '/admin';
      console.log('✅ Redirecting to Admin Dashboard:', redirectPath);
    } else if (userRole === 'country_director') {
      redirectPath = '/director';
      console.log('✅ Redirecting to Director Dashboard:', redirectPath);
    } else {
      redirectPath = '/dashboard';
      console.log('✅ Redirecting to User Dashboard:', redirectPath);
    }

    // Use intended path only if it matches the user's role access
    const intendedPath = location.state?.from?.pathname;
    if (intendedPath) {
      console.log('📍 Intended path found:', intendedPath);
      if (userRole === 'admin' || userRole === 'super_admin') {
        // Admins can access any path, but default to admin dashboard
        redirectPath = intendedPath.startsWith('/admin') ? intendedPath : '/admin';
      } else if (userRole === 'country_director') {
        // Directors can access director or user paths
        redirectPath = intendedPath.startsWith('/director') || intendedPath.startsWith('/dashboard') ? intendedPath : '/director';
      } else {
        // Regular users can only access user paths
        redirectPath = intendedPath.startsWith('/admin') || intendedPath.startsWith('/director') ? '/dashboard' : intendedPath;
      }
    }

    console.log('🚀 Final redirect path:', redirectPath);
    navigate(redirectPath, { replace: true });
  };

  // Handle successful membership registration
  const handleMembershipSuccess = () => {
    toast.success('Membership application submitted successfully!');
    navigate('/dashboard');
  };

  // Handle sign out
  const handleSignOut = () => {
    logout();
    toast.info('Signed out successfully');
    navigate('/', { replace: true });
  };

  // Navigate to membership form
  const navigateToMembership = () => {
    navigate('/membership');
  };

  // Navigate to sign in
  const navigateToSignIn = () => {
    navigate('/signin');
  };

  return {
    handleAuthSuccess,
    handleMembershipSuccess,
    handleSignOut,
    navigateToMembership,
    navigateToSignIn
  };
};